import currencyService from "../services/currencyService";

export const GET_CURRENCY_RATE = "GET_CURRENCY_RATE";
export const GET_CURRENCY_RATE_SUCCESS =
    "GET_CURRENCY_RATE_SUCCESS";
export const GET_CURRENCY_RATE_ERROR =
    "GET_CURRENCY_RATE_ERROR";

export function getCurrencyRateRecord() {
    return async (dispatch) => {
        dispatch(getCurrencyRate());
        return await currencyService
            .getCurrencyRate()

            .then((response) =>
                dispatch(getCurrencyRateSuccess(response.data))
            )
            .catch((error) => dispatch(getCurrencyRateError(error)));
    };
}

export function getCurrencyRate() {
    return {
        type: GET_CURRENCY_RATE,
    };
}

export function getCurrencyRateSuccess(success) {
    return {
        type: GET_CURRENCY_RATE_SUCCESS,
        payload: { success },
    };
}

export function getCurrencyRateError(error) {
    return {
        type: GET_CURRENCY_RATE_ERROR,
        payload: { error },
    };
}